import {
    DockviewReact,
    DockviewReadyEvent,
    IDockviewPanelProps,
} from 'dockview';
import React, { useState } from 'react';
import '@/assets/docview.css'
import UseTools from '@/views/useTools/useTools';
import "@fortune-sheet/react/dist/index.css"
import { ArrowLeft,  Settings, Share2 } from 'lucide-react';
import { Link } from "react-router-dom";


const components = {
    data: (props: IDockviewPanelProps<{ properties: string, setProperties: React.Dispatch<React.SetStateAction<string>> }>) => {
        return (

                <>
                    Tool Output
                </>

        );
    },

};

export const UseToolsPage: React.FC = (props: { theme?: string }) => {
    const [properties, setProperties] = useState<string>('');
    const onReady = (event: DockviewReadyEvent) => {  
        const workspace = event.api.addPanel({
            id: 'data',
            component: 'data',
            title: 'Data',
        });
    };

    const [isToggle, setIsToggle] = useState(false)
    const OnToggle = () => {
        setIsToggle(!isToggle)
    }

    return (
        <div className='flex flex-col h-full  p-2' >
                <div className='flex justify-between items-center p-4'>
                    <div className='flex items-center'>
                        <Link to={`/tool`}>
                        <ArrowLeft className="h-4 w-4 mr-2" /></Link>
                        <h2 className='text-lg font-bold'>Use Tool</h2>
                    </div>
                    <div className='flex space-x-2'>
                        <button className='p-2'>
                            <Settings className="h-4 w-4" />
                        </button>
                        <button className='p-2'>
                            <Share2 className="h-4 w-4" />
                        </button>
                        <button className='p-2'>
                            API
                        </button>
                    </div>
                </div>
            <div className='flex flex-row h-full'>
            <div className={`ml-2 ${isToggle ? 'w-1/2' : 'w-full'} `}>

               <UseTools OnToggle={OnToggle} isToggle={isToggle} />
            </div>

           {isToggle && <div className='flex-grow flex w-1/2'>
                <div className='w-full'>
                    <DockviewReact
                        components={components}
                        onReady={onReady}
                        className={`${props.theme || 'dockview-theme-replit'}`}
                    />
                </div>
            </div>
            }
        </div>

        </div>
    );
};

export default UseToolsPage;
